// extracted by mini-css-extract-plugin
module.exports = {"dropdownIndicator":"styles_dropdownIndicator__2SZbJ","boxArrow":"styles_boxArrow__qUwyO"};